module.exports = __webpack_public_path__ + "img/brazil.e87ee1b0.png";